export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bonus Powitalny"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spróbuj Swojego Szczęścia!"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wygrałeś"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kręć kołem i otrzymaj środki testowe do eksploracji wszystkich funkcji platformy."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Te środki są do testowania."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zanurz się i doświadcz wszystkich funkcji."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kręć"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbierz"])}
}